import { Injectable } from '@angular/core';
import {BsModalService} from 'ngx-bootstrap/modal';
import {LedgerSyncModalComponent} from '@shared/ledger-sync-modal/ledger-sync-modal.component';
import {LS_MODAL_LOCALSTORAGE_PATH} from '@shared/ledger-sync-modal/constants';
import {ILSMDontShow, ILSModalOptions} from '@shared/ledger-sync-modal/interface';
import {LocalStorageService} from '@services/local-storage.service';

@Injectable({
  providedIn: 'root'
})
export class LedgerSyncModalService {
  constructor(
    private modalService: BsModalService,
    private localStorageService: LocalStorageService,
  ) { }

  show(initialState: ILSModalOptions, modalClass?: string) {
    const {dontShow} = initialState;
    if (this.needShow(dontShow)) {
      return this.modalService.show(LedgerSyncModalComponent, {
        initialState,
        class: modalClass,
      });
    }
  }

  updateDontShow(dontShow: ILSMDontShow) {
    const {dontShowAgainId} = dontShow;
    let dsList = this.getDontShowList();
    if (dsList.includes(dontShowAgainId)) {
      dsList = dsList.filter((item) => item !== dontShowAgainId);
    } else {
      dsList.push(dontShowAgainId);
    }
    this.localStorageService.setValue(LS_MODAL_LOCALSTORAGE_PATH, JSON.stringify(dsList));
  }

  private needShow(dontShow: ILSMDontShow) {
    const {dontShowAgain, dontShowAgainId} = dontShow || {};
    if (!dontShowAgain) {
      return true;
    }
    return !this.getDontShowList().includes(dontShowAgainId);
  }

  private getDontShowList(): string[] {
    const data = this.localStorageService.getValue(LS_MODAL_LOCALSTORAGE_PATH);
    try {
      return JSON.parse(data) || [];
    } catch {
      return [];
    }
  }
}
